
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { socialCardKeys } from 'src/constants/socialcard.constant'
import dayjs from 'dayjs';

import { textColors } from 'src/constants/wall.constant';

import ClassNames from 'src/components/componentHelper/ClassNames'

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const GreyTextColoredCard = ({ cardWidth, cardItem,fontStyle, darkModeEnabled, cardFontColor, cardBackgroundObject, darkCardTheme, linkColor, highlightColor, engagementDisabled, smallSize, refresh, shortenText, isDateTimeDisabled, ratingColor, quotationColor}) => {
        
    const options = {
        replace: domNode => {
           const attribProps = attributesToProps(domNode.attribs);
    
           if (domNode.name === 'a') {
              return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
           }
    
           else if(domNode.name === 'b'){
            let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
            if (darkModeEnabled) {
              bStyle.color = '#726c6c';
            }
            return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
         }
        }
     }

    return (
   
        <div 
        className={ClassNames(" inline-block w-full rounded-2xl p-8 text-sm leading-6 shadow-md",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')}
        style={
              { ...(cardBackgroundObject?cardBackgroundObject:{}), boxShadow:"rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px" }
          }
        >
                            {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!=='' &&
                          <div className="tweet-content" style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.05em":"1.0em",lineHeight: !smallSize? '1.5em': '1.625em' }}>
                            {
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={`“${cardItem[socialCardKeys.messageContent]}”`} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(`“${cardItem[socialCardKeys.messageContent]}”`,options)
            }
                            </div>
                            }

                            {
                  cardItem[socialCardKeys.messageMediaImage] ?
                  <div className="mt-2 flex justify-center w-full mb-4" style={{width: '100%', position: 'relative'}}>

                  <img className="h-auto w-auto rounded-md" onLoad={()=>refresh()} objectFit="contain" style={{ width: '100%', borderRadius:'10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Image" />

               </div>

               :
               null
    }
    
                            {
        (cardItem[socialCardKeys.starRating] && cardItem[socialCardKeys.starRating]>0) ?
                <ul className="flex justify-start mt-2">
                   {
                     [...Array(Math.min(5,Math.floor(cardItem[socialCardKeys.starRating])))].map((e,i) =>
                   <li key={e}>
                     <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}}
                       role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                       <path fill="currentColor"
                         d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z">
                       </path>
                     </svg>
                   </li>
                     )
                   }
                   {
                    (cardItem[socialCardKeys.starRating]%1===0.5) &&
                       <li>
                       <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star-half-alt"
                         className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}} role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536 512">
                         <path fill="currentColor"
                           d="M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z">
                         </path>
                       </svg>
                     </li>
                   }

                 </ul>
                 :
                 null
                 }
                 { (!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ?
                 <div className={(cardItem[socialCardKeys.starRating] && cardItem[socialCardKeys.starRating]>0) ? "mt-4 text-xs" : "mt-2 text-xs"} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary) } : { color: (cardFontColor || textColors.light.secondary) }}>{dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY')}</div>
                 :
                 null
                 }
                            <figcaption className="mt-6 flex items-center gap-x-3">
                            <img 
                              className="h-10 w-10 rounded-full bg-gray-50" 
                              src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0e1e1&color=47476b&size=48`}                              
                              alt="" 
                              />
                           
                              <div className='grid text-sm'>
                              <a className="text-gray-900 font-semibold" href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), textDecoration: 'none' } : { color: (cardFontColor || textColors.light.primary), textDecoration: 'none' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">{cardItem[socialCardKeys.authorName]}</a>
                              { (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='')  ?
        <a className={ClassNames(!darkModeEnabled ? 'text-gray-600 ' : 'text-gray-300 ','mt-1 text-xs')} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.workTitle]}</a>
        :
          (cardItem[socialCardKeys.authorTagline] && cardItem[socialCardKeys.authorTagline]!=='') ?
          <a className={ClassNames(!darkModeEnabled ? 'text-gray-600 ' : 'text-gray-300 ','mt-1 text-xs')} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target="_blank" rel="noreferrer noopener">{cardItem[socialCardKeys.authorTagline]}</a>

            :
              (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!=='') ?
              <a className={ClassNames(!darkModeEnabled ? 'text-gray-600 ' : 'text-gray-300 ','mt-1 text-xs')} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target="_blank" rel="noreferrer noopener">       
                    {`@${cardItem[socialCardKeys.authorUsername]}`}
                </a>
                :
                null
        }
                                {/* <div className="text-gray-600">{`@${testimonial.author.handle}`}</div> */}
                              </div>
                            </figcaption>
                        </div>
            )    
}

export default GreyTextColoredCard;